module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNERTNCMzAiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNGQUNEMzMiIGQ9Ik0xMjggMzh2ODlsLTEgMUgzOGw5MC05MHoiLz48cGF0aCBmaWxsPSIjMDAwMDAwIiBkPSJNMSAwaDg5TDAgOTBWMWwxLTF6Ii8+PHRleHQgZmlsbD0iI0ZGRkZGRiIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjY0Ij48dHNwYW4geD0iMTkiIHk9Ijg1Ij5ERTwvdHNwYW4+PC90ZXh0PjwvZz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/language-icons/icons/de.svg
// module id = LWt6
// module chunks = 1